import { render, staticRenderFns } from "./InstitutionsMap.vue?vue&type=template&id=52a8b82c&"
import script from "./InstitutionsMap.vue?vue&type=script&lang=js&"
export * from "./InstitutionsMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports